import types from "./systemlog.types";
import {API_END, API_START} from "../api/types";
import {types as auth_types} from "../auth/auth.types";

export const initialState = {
    systemLogs: [],
    isLoadingSystemLogsListData: false,
    selectedSystemLog: {},
    systemLogFieldErrors: {},

}

export default function moduleReducer(state = initialState, action) {
    switch (action.type) {
        case auth_types.AUTH_LOGIN:
            return initialState;
        case auth_types.AUTH_LOGOUT:
            return initialState;
        case types.SET_SYSTEM_LOGS_LIST:
            return {
                ...state,
                systemLogs: action.payload
            }
        case types.SET_SYSTEM_LOG:
            return {
                ...state,
                systemLogFieldErrors: {},
                selectedSystemLog: action.payload
            }
        case types.UNSET_SYSTEM_LOG:
            return {
                ...state,
                systemLogFieldErrors: {},
                selectedSystemLog: {}
            }
        case API_START:
            if (action.payload === types.FETCH_SYSTEM_LOGS_LIST) {
                return {
                    ...state,
                    isLoadingSystemLogsListData: true
                };
            }
            return state
        case API_END:
            if (action.payload === types.FETCH_SYSTEM_LOGS_LIST) {
                return {
                    ...state,
                    isLoadingSystemLogsListData: false
                };
            }
            return state
        case types.SYSTEM_LOG_API_ERROR:
            if (action.payload == null) {
                return state;
            }
            if (typeof action.payload === "string") {
                console.log("API error: " + action.payload)
                return state
            } else if ('status' in action.payload && action.payload.status === 405) {
                console.log("API error: " + action.payload.error)
                return state
            } else if ('data' in action.payload && action.payload.data !== null) {
                console.log("API error: " + action.payload.message)
                return {
                    ...state,
                    systemLogFieldErrors: action.payload.data
                }
            } else {
                console.log("API error: " + action.payload)
                return state
            }
        default:
            // Do not use the default case
            // A dispatch action will pass through each of the reducers associated with this one.
            // An action at the other end of your application could affect this state
            // without being expressed in the code. This should be avoided.
            return state
    }
}
